import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import {Headers, Http} from '@angular/http';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {

  /**
   * Inject required dependencies.
   * @param authService
   * @param router
   */
  constructor(
    private authService: AuthService,
    private router: Router,
    private http: Http
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const isLoggedIn = this.authService.isLoggedIn();


    isLoggedIn.subscribe(loggedIn => {
      if (false === loggedIn) {

        localStorage.setItem('redirectURL', window.location.pathname)
        let search = window.location.search
        if (search) {

        const headers = new Headers();
        const sIdSession = search.substring(search.indexOf('=') + 1);
        if (sIdSession) {
            headers.append('Bonanza-Session-Id', sIdSession);
            headers.append('Accept', 'application/json');
        }

        this.http.get(environment.apiBaseUrl + 'user/sessionData', {headers: headers})
        .map(response => response.json())
        .subscribe(session => {
            if (!session.sessionId) {
                session.sessionId = headers.get('Bonanza-Session-Id');
            }
            localStorage.setItem('sessionData', JSON.stringify(session))
            this.authService.setSession(session);
            this.router.navigate([localStorage.getItem('redirectURL')]);
        });
      }else {
        this.router.navigate(['/login']);
      }
    }
    });

    return isLoggedIn;
  }
}


// else {
//   if (localStorage.getItem('sessionId') !== window.location.search.substring(window.location.search.indexOf('=') + 1)) {
//     localStorage.setItem('redirectURL', window.location.pathname)
//     let search = window.location.search
//     if (search) {

//     const headers = new Headers();
//     const sIdSession = search.substring(search.indexOf('=') + 1);
//     if (sIdSession) {
//         headers.append('Bonanza-Session-Id', sIdSession);
//         headers.append('Accept', 'application/json');
//     }

//     this.http.get(environment.apiBaseUrl + 'user/sessionData', {headers: headers})
//     .map(response => response.json())
//     .subscribe(session => {
//         if (!session.sessionId) {
//             session.sessionId = headers.get('Bonanza-Session-Id');
//         }
//         localStorage.setItem('sessionData', JSON.stringify(session))
//         this.authService.setSession(session);
//         this.router.navigate([localStorage.getItem('redirectURL')]);
//     });
//   }
// }
// }



// WEBPACK FOOTER //
// ./src/app/users/auth.guard.ts